export const CONFIRMED_GET_PATIENT_LIST = "CONFIRMED_GET_PATIENT_LIST";
